export default __webpack_public_path__ + "static/media/PSO 08 - Amarração Tubos - Mat. Equipamentos (Rev. 00 - xx.xx.2025).b2c00910.pdf";